import CertificationCard from './CertificationCard';
export default CertificationCard;
